import React, { useState } from "react";
import axios from "axios";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Input, Toast } from "../ui";
import { appConstants } from "../_constants/app.constants";
import { validatePassword } from "./passwordValidation";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const email = (searchParams.get("email") || "").trim();
  const token = (searchParams.get("token") || "").trim();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const linkIsComplete = Boolean(email && token);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    const validationError = validatePassword(password);
    if (validationError) {
      setError(validationError);
      return;
    }
    if (password !== confirmation) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setSubmitting(true);
    try {
      await axios.post(`${appConstants.API_URL}/api/auth/reset-password`, {
        email,
        token,
        newPassword: password,
      });
      setCompleted(true);
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.Message ||
        "No se pudo cambiar la contraseña. Solicita un enlace nuevo.";
      setError(typeof message === "string" ? message : "No se pudo cambiar la contraseña.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-cream via-white to-cream-deep px-4 py-12">
      <div className="pointer-events-none absolute inset-0 bg-noise opacity-30 mix-blend-multiply" aria-hidden />
      <div className="relative z-10 mx-auto flex min-h-[80vh] w-full max-w-md items-center">
        <Card className="w-full overflow-hidden">
          <div className="h-1 bg-gradient-to-r from-gold via-gold-bright to-arena-bright" />
          <CardHeader className="pb-1 pt-6">
            <h1 className="font-display text-3xl font-extrabold text-ink">Nueva contraseña</h1>
            <p className="mt-1 text-sm text-ink-muted">
              Elige una contraseña distinta para proteger tu cuenta.
            </p>
          </CardHeader>
          <CardBody className="pb-6">
            {!linkIsComplete ? (
              <>
                <Toast kind="error" className="mb-4">
                  El enlace está incompleto. Solicita uno nuevo desde el login.
                </Toast>
                <Button as={RouterLink} to="/forgot-password" variant="primary" size="lg" className="w-full">
                  Pedir un enlace nuevo
                </Button>
              </>
            ) : completed ? (
              <>
                <Toast kind="success" className="mb-4">
                  Contraseña actualizada. Se han cerrado las sesiones anteriores de tu cuenta.
                </Toast>
                <Button as={RouterLink} to="/login" variant="primary" size="lg" className="w-full">
                  Iniciar sesión
                </Button>
              </>
            ) : (
              <>
                {error ? <Toast kind="error" className="mb-4">{error}</Toast> : null}
                <form onSubmit={handleSubmit} className="space-y-3">
                  <Input
                    label="Nueva contraseña"
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    helperText="Mínimo 8 caracteres, con mayúscula, minúscula y número."
                    required
                  />
                  <Input
                    label="Repite la contraseña"
                    type="password"
                    autoComplete="new-password"
                    value={confirmation}
                    onChange={(event) => setConfirmation(event.target.value)}
                    required
                  />
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="mt-3 w-full"
                    disabled={submitting}
                  >
                    {submitting ? "Actualizando..." : "Guardar nueva contraseña"}
                  </Button>
                </form>
              </>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
